var exports = {
  "a": "Box__zSN7uU",
};

module.exports = exports;
